import {
    ApiHandlerNoParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { getApplePayConfig, ApplePayConfig } from "@insite/client-framework/Services/SettingsService";

type HandlerType = ApiHandlerNoParameter<ApplePayConfig>;

export const GetApplePayConfig: HandlerType = async props => {
    props.apiResult = await getApplePayConfig();
};

export const DispatchCompleteLoadApplePayConfig: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteLoadApplePayConfig",
        applePayConfig: props.apiResult,
    });
};

export const chain = [GetApplePayConfig, DispatchCompleteLoadApplePayConfig];

const loadApplePayConfig = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadApplePayConfig");
export default loadApplePayConfig;
